import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`

export const NoteList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp12};
`
